<!--
 * @Description: 
 * @Autor: wk
 * @Date: 2019-05-18 10:42:34
 * @LastEditors: lkz
 * @LastEditTime: 2021-11-04 15:36:26
 -->
<template>
  <div id="app" class="imporjuect_box" :class="{ showbox: !slideflgs }" :style="{ padding: paddings, transition: ms }">
    <el-alert v-if="!version" class="window-version-tip" title="" type="error">
      为保障系统正常使用，请使用<a href="https://www.google.cn/chrome/">谷歌浏览器</a>
    </el-alert>
    <div class="silder_box" v-if="afterStatus">
      <Slider :slideflg.sync="slideflgs"></Slider>
    </div>
    <div class="totop" v-if="afterStatus">
      <Totop :slideflg.sync="slideflgs"></Totop>
    </div>
    <div class="container">
      <router-view></router-view>
    </div>
    <ServiceMessageDarwer ref="ServiceMessageDarwerRef"></ServiceMessageDarwer>
  </div>
</template>
<script>
// @ is an alias to /src
import HelloWorld from 'views/basePages/about'
import Slider from 'components/slider/slider'
import Totop from 'components/totop/totop'
import ServiceMessageDarwer from 'components/ServiceMessageDarwer/index'
// @ is an alias to /src
import YunJi from 'utils/old/YunJi.js'

const hideArr = [
  '/allWorkOrderList',
  '/myTask',
  '/workOrderManagement/workOrderLimit',
  ''
]

export default {
  name: 'home',
  data() {
    return {
      slideflgs: true,
      afterStatus: false,
      paddings: '',
      ms: '',
      version: false,
      appCont: this.$route.query.appCont || 0
    }
  },
  watch: {
    $route(val) {
      this.afterStatus = true
      const { hiddenMenu } = val.query
      if (val.name === '/work' || val.name === '/workOrderDetail' || (val.name === '/searchIndex' && !this.$route.query.phone)) {
        this.slideflgs = false
        this.paddings = '59px 0 0 180px'
      } else if (val.name === '/addAfterOrder' 
      || val.name === '/addSendSms' 
      || val.name === '/seesionList_box' 
      || (val.name === '/searchIndex' && this.$route.query.phone) 
      || val.name === 'login'
      || val.name === 'resetPassword'
      || val.path.indexOf('businessHelpCenter') > 0
      || val.name === '/createWorkOrder'
      // || ((val.name === '/allWorkOrderList' || val.name === '/myTask') && this.$route.query.hide)) {
      || ((hideArr.includes(val.name)) && this.$route.query.hide)) {
        this.paddings = 0
        this.afterStatus = false
        this.ms = 'all 0s ease'
      } else if (hiddenMenu && Number(hiddenMenu) !== 0) {
        this.paddings = 0
        this.afterStatus = false
        this.ms = 'all 0s ease'
      } else {
        this.paddings = '59px 0 0 180px'
      }
    }
  },
  computed: {},
  components: {
    HelloWorld,
    Slider,
    Totop,
    ServiceMessageDarwer
  },
  created() {
    this.version = navigator.userAgent.indexOf('Chrome') >= 0
  },
  async mounted() {
    this.initBaseBus()
    this.initThinkingReport() // 初始化数数埋点
  },
  methods: {
    /**
    * 数数埋点数据上报
    */
    initThinkingReport() {
      /* eslint-disable */
      let appId = ""
      const appCont = parseFloat(this.appCont)
      // console.log('t-do-dev.yunjiglobal.com', location.href.indexOf('t-do-dev.yunjiglobal.com') > -1)
      if (location.href.indexOf('xinyun.yunjiglobal.com') > -1) {
      // if (location.href.indexOf('t-do-dev.yunjiglobal.com') > -1) { // TODO:换线上域名
        // 正式
        if (appCont === 0) {
          appId = 'ba036c847ebf492ab5dcef1de530b44e'
        } else if (appCont === 1) { // identity_type有值则为app合并，app合并就将点报在卖家版表里
          appId = '48df4d00dffb488889293dc20521e31d'
        } else if (appCont === 2) {
          appId = 'f0edd6e68c6949da94a4a8ae3678b0f7'
        }
      } else {
        // 测试
        if (appCont === 0) {
          appId = '587f69909c9749ac8f98562527e948a2'
        } else if (appCont === 1 ) { // identity_type有值则为app合并，app合并就将点报在卖家版表里
          appId = '78cbafbbb0a94edb85126bf7350c198e'
        } else if (appCont === 2) {
          appId = '2cf61875c9f9487c968e9da49102b71b'
        }
      }
      (function (param) {
        const p = param.sdkUrl
        const n = param.name
        const w = window
        const d = document
        const s = 'script'
        let x = null
        let y = null
        w.ThinkingDataAnalyticalTool = n
        w[n] = w[n]
          || function (a) {
            return function () {
              (w[n]._q = w[n]._q || []).push([a, arguments])
            }
          }
        const methods = [
          'track',
          'quick',
          'login',
          'logout',
          'trackLink',
          'userSet',
          'userSetOnce',
          'userAdd',
          'userDel',
          'setPageProperty'
        ]
        for (let i = 0; i < methods.length; i++) {
          w[n][methods[i]] = w[n].call(null, methods[i])
        }
        if (!w[n]._t) {
          (x = d.createElement(s)), (y = d.getElementsByTagName(s)[0])
          x.async = 1
          x.src = p
          y.parentNode.insertBefore(x, y)
          w[n].param = param
        }
      }({
        appId: appId, // 系统分配的APPID
        name: 'thinkingReport', // 全局的调用变量名，可以任意设置，后续的调用使用该名称即可
        sdkUrl: 'https://static.yunjiglobal.com/qnUpload/frontend/js/thinkingdata_1.0.5.js', // 统计脚本URL
        serverUrl: '//ta.yunjiglobal.com/sync_js',
        send_method: 'ajax',
        showLog: false
      }))
      if (appCont == 0) {
        // H5传的是consumer_id
        const consumer_id = YunJi.getCookie('burial_point_cid')
        const union_id = YunJi.getCookie('burial_point_wx_id')
        if (consumer_id) {
          thinkingReport.setPageProperty({ consumer_id: consumer_id })
          thinkingReport.login(consumer_id)
        }
      } else if (appCont == 1 || appCont == 2 || (YunJi.appUA && YunJi.appUA.identity_type)) { // identity_type有值则为app合并，app合并就将点报在卖家版表里
        if(appCont == 1){
          // 卖家版传的是shopId
          if (YunJi.appUA.shop_id && YunJi.appUA.shop_id !== "null") {
            thinkingReport.login(YunJi.appUA.shop_id);
          } else if (YunJi.getUrlParams("shopId")) {
            thinkingReport.login(YunJi.getUrlParams("shopId"));
          } else {
            thinkingReport.logout();
          }
        }else if(appCont == 2){
          // vip传的是user_id  也就是 consumer_id
          if (YunJi.appUA.user_id && YunJi.appUA.user_id !== "null") {
            thinkingReport.login(YunJi.appUA.user_id);
          } else {
            thinkingReport.logout();
          }
        }
      }
      thinkingReport.setPageProperty({"#app_version": YunJi.appUA.appVersion});
      thinkingReport.setPageProperty({ "#os": YunJi.appUA.appClient });
      if (YunJi.appUA.identity_type) { thinkingReport.setPageProperty({ identity_type: YunJi.appUA.identity_type }) }
      if (YunJi.appUA.mobile_id) { thinkingReport.setPageProperty({ mobile_id: YunJi.appUA.mobile_id }) }
      if (YunJi.appUA.mobile_system) { thinkingReport.setPageProperty({ mobile_system: YunJi.appUA.mobile_system }) }
      if (YunJi.appUA.mobile) { thinkingReport.setPageProperty({ mobile: YunJi.appUA.mobile }) }
      if(YunJi.appUA.appOrigin){thinkingReport.setPageProperty({ "app_origin": YunJi.appUA.appOrigin });}
      /* eslint-enable */
    },
    // 初始化
    initBaseBus() {
      this.$root.$on('baseBusFn', (query) => {
        console.log(2222, query)
        if (!query) return
        switch (query.name) {
          case 'openServiceMessageDarwer':
            this.openServiceMessageDarwer(query.params)
            break
          default:
            break
        }
      })
    },
    // 全局打开留言抽屉
    openServiceMessageDarwer(params) {
      this.$refs.ServiceMessageDarwerRef.open(params)
    }
  }
}
</script>
<style lang="less">
@import '~styles/var.less';
html,
body {
  background: #f2f5f7;
}
#app {
  font-family: '12px PingFang SC,Microsoft YaHei,San Francisco,SimSunHelvetica Neue';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #f2f5f7;
  font-size: 12px;
}
.imporjuect_box {
  position: relative;
  padding: 59px 0 0 180px;
  transition: all 0.5s ease;
  .silder_box {
    transition: all 0.5s ease;
    position: fixed;
    left: 0;
    top: 0;
    width: 180px;
    height: 100%;
  }
}
.container {
  min-width: 100%;
  position: relative;
  overflow: hidden;
}
.totop {
  transition: all 0.5s ease;
  position: absolute;
  left: 180px;
  top: 0;
  height: 59px;
  z-index: 99;
  right: 0;
}
.showbox {
  padding-left: 56px!important;
  .silder_box {
    width: 56px;
  }
  .totop {
    left: 56px;
  }
  .silder_box {
    .el-menu-item i {
      margin-right: 50px !important;
    }
    font-size: 0 !important;
  }
  .slider_top {
    img {
      margin-right: 50px;
    }
  }
  .el-menu span i {
    margin-right: 100px;
  }
  .showboxspan {
    display: none !important;
  }
}
.el-message-box__status.el-icon-warning {
  top: 42%;
}
.el-message-box__btns .el-button:first-child {
  order: 0 !important;
}
.el-time-panel{
  width:150px!important;
}
</style>
